import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WorkspaceTab } from '../tab-workspace.service';

@Component({
  selector: 'app-sidebar',
  imports: [
    CommonModule
  ],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss'
})
export class SidebarComponent {
  @Input() tabs: WorkspaceTab[] = [];
  @Input() activeTabId: string | null = null;

  @Output() readonly addTab = new EventEmitter<void>();
  @Output() readonly switchTab = new EventEmitter<string>();
  @Output() readonly closeTab = new EventEmitter<string>();

  onAddTab(): void {
    this.addTab.emit();
  }

  onSwitchTab(tabId: string): void {
    this.switchTab.emit(tabId);
  }

  @HostListener('document:keydown', ['$event'])
  onDocumentKeydown(event: KeyboardEvent): void {
    if (!event.ctrlKey || event.key !== 'Tab' || this.tabs.length < 2) return;
    event.preventDefault();

    const currentIndex = this.tabs.findIndex(t => t.id === this.activeTabId);
    const next = event.shiftKey
      ? (currentIndex - 1 + this.tabs.length) % this.tabs.length
      : (currentIndex + 1) % this.tabs.length;

    this.onSwitchTab(this.tabs[next].id);
  }

  onTabKeydown(event: KeyboardEvent, tabId: string): void {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.onSwitchTab(tabId);
    }
  }

  onCloseTab(event: MouseEvent, tabId: string): void {
    event.stopPropagation();
    this.closeTab.emit(tabId);
  }

  getDisplayTitle(tab: WorkspaceTab): string {
    if (tab.displayTitle) {
      return tab.displayTitle;
    }
    return tab.title;
  }

  private extractFlightNumber(url: string): string | null {
    const match = url.match(/flightNumber=([^&]+)/);
    return match ? match[1] : null;
  }

  private extractFlightRegistrationNumber(url: string): string | null {
    const match = url.match(/flightRegistration=([^&]+)/);
    return match ? match[1] : null;
  }

  private extractFlightDate(url: string): string | null {
    const match = url.match(/flightDate=([^&]+)/);
    return match ? match[1] : null;
  }

  private formatFlightDate(rawDate: string | null): string | null {
    if (!rawDate) return null;

    let decodedDate = rawDate;
    try {
      decodedDate = decodeURIComponent(rawDate);
    } catch {
      // keep raw value if decoding fails
    }

    const date = new Date(decodedDate);
    if (Number.isNaN(date.getTime())) {
      return null;
    }

    return date
      .toLocaleDateString('en-GB', {
        day: '2-digit',
        month: 'short'
      })
      .replace(' ', '/');
  }

  private extractFlightLegId(url: string): string | null {
    // Match patterns like: flightLegId=123 or /123/ or ?id=123
    const patterns = [
      /flightLegId=([^&]+)/,
      /\/(\d+)\//,
      /\/(\d+)$/,
      /[?&]id=([^&]+)/
    ];

    for (const pattern of patterns) {
      const match = url.match(pattern);
      if (match && match[1]) {
        return match[1];
      }
    }

    return null;
  }
}
